<template>
  <CRow style="margin-top: 50px">
    <CCol col="12" md="12">
      <CCard>
        <CCardBody>
          <form-wizard
            @on-change="onchangetab"
            @on-complete="onComplete"
            @on-validate="handleValidation"
            title=""
            subtitle=""
          >
            <!-- :before-change="validateTab" -->
            <tab-content
              title="Company details"
              :before-change="() => validateStep('form1')"
            >
              <Form1
                @pass1="onform1change"
                ref="form1"
                @on-validated="onStepOneValidated"
              ></Form1>
            </tab-content>
            <tab-content
              title="Additional Info"
              :before-change="() => validateStep('form2')"
            >
              <Form2 @pass2="onform2change" ref="form2"></Form2>
            </tab-content>
            <tab-content title="Last step">
              <Form3 ref="form3"></Form3>
            </tab-content>
          </form-wizard>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from "../tables/Table";
import { APIService } from "../../apiservice.js";
import Swal from "sweetalert2";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import Form1 from "./form1.vue";
import Form2 from "./form2.vue";
import Form3 from "./form3.vue";
var CryptoJS = require("crypto-js");
import firebase from "firebase";
const db = firebase.firestore();
export default {
  components: { CTableWrapper, FormWizard, TabContent, Form1, Form2, Form3 },
  props: {
    title: {
      type: String,
      default: " ",
    },
    subtitle: {
      type: String,
      default: "Split a complicated flow in multiple steps",
    },
  },
  data() {
    return {
      data: "",
      isNft:false,
      FormData1: {},
      FormData2: {},
      FormValid: {},
    };
  },
  mounted() {
    this.$root.$on("passdone", (value) => {
      //  console.log("this.token received")
      this.onchangetab();
    });
  },
  methods: {
    validateStep(ref) {
      // window.scrollTo(0, 0);
      // console.log("ref",ref)
      return this.$refs[ref].validate();
    },

    handleValidation: function (isValid, tabIndex) {
      // console.log("Tab: " + tabIndex + " valid: " + isValid);
    },

    onchangetab(prev, next) {
      if (prev == 0) {
        this.$refs["form1"].nextTab();
      }
      if (prev == 1) {
        this.$refs["form2"].nextTab();
      }
      if (prev == 2) {
        this.$refs["form3"].nextTab();
      }
    },
    onform1change(data) {
      this.$root.$emit("pass4", data);
      this.FormData1 = data;
      // console.log("firstdata",this.FormData1);
    },
    onform2change(data) {
      this.$root.$emit("pass5", data);
      // console.log("Form", data);
      this.FormData2 = data;
    },
    onComplete: function () {
      console.log("integer",this.FormData2.tokencircle)
      var password = "2020+SmartChat/Encrypt@";
      let self = this;

      db.collection("companyDetails2")
        .add({
          data: this.data,
          name: this.FormData1.name,
          isBalance:this.FormData1.isBalance,
          tokenRefreshRate:parseInt(this.FormData1.tokenRefreshRate),
          minDistance:parseInt(this.FormData1.minDistance),
          radius: parseInt(this.FormData1.tokenrage),
          symbol: this.FormData1.symbol,
          availableSupply: parseInt(this.FormData2.supply),
          totalSupply: parseInt(this.FormData2.supply),
          companyName: this.FormData1.CompanyName,
          linkedinID: this.FormData1.linkedID,
          twitterID: this.FormData1.twitterId,
          description: this.FormData1.description,
          ethAddress: this.FormData1.ethAddress,
          conAddress: this.FormData1.conAddress,
          showMax: parseInt(this.FormData1.tokenlimit),
          // privatekey: this.FormData1.privatekey,
          NFT: this.FormData1.isNft,
          isNft:this.isNft,
          networkimage: this.FormData1.networkimage,
          userLimit: parseInt(this.FormData1.Userlimit),
          coinLimit: parseInt(this.FormData1.coinLimit),
              privatekey: CryptoJS.AES.encrypt(
            this.FormData1.privatekey,
            password
          ).toString(),
          displaylogo: this.FormData1.displaylogo,
          capturelogo: this.FormData1.capturelogo,
          arLogo: this.FormData1.threelogo,
          popuplogo: this.FormData1.popuplogo,
          network: this.FormData1.network,
          country: this.FormData2.country,
          istokenmsg: this.FormData2.istokenmsg,
          istokenmsglink: this.FormData2.istokenmsglink,
          messagelink: this.FormData2.messagelink,
          tokencircle: this.FormData2.tokencircle,
          whiteList: this.FormData2.csvdata,
          location: this.FormData2.location,
          allCountry: this.FormData2.allCountry,
          particularCountry: this.FormData2.particularCountry,
          logo: this.FormData1.logo,
          isWhiteList: this.FormData2.isWhiteList,
          videoupload: this.FormData2.videoupload,
          isVideoselected: this.FormData2.isVideoselected,
          coinQty: parseInt(this.FormData1.coinQty),
          isCoinLimit: this.FormData1.isCoinLimit,
          ismaxLimit: this.FormData1.ismaxLimit,
          dailyLimit: parseInt(this.FormData1.dailyLimit),
          maxLimit: parseInt(this.FormData1.maxLimit),
          isRandomLocation:this.FormData1.isRandomLocation,
          audiofile:this.FormData1.nftAudio,
          nftImage:this.FormData1.nftImageurl,
          message: [
            this.FormData2.msg1,
            this.FormData2.msg2,
            this.FormData2.msg3,
            this.FormData2.msg4,
            this.FormData2.msg5,
            this.FormData2.msg6,
          ],
        })
        .then(() => {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 3000,
          });
          self.$router.push({ name: "tokenEntry" });
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
    },

    wizard() {
      // console.log("tokenEntry page");
      this.$router.push({ name: "tokenEntry" });
    },

    rowClicked(item, index, column, e) {
      // console.log("edit item", item, index, column, e);

      this.editSpecies = item;
      this.speciesCode = item.speciesCode;
      this.speciesName = item.speciesName;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false;
    },

    delete() {
      let id = this.editSpecies._id;
      let data = { id };
      APIService.speciesDelete(data).then((res) => {
        if (res.status == 200) {
          this.speciesCode = null;
          this.speciesName = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          (this.EditsaveButton = false), this.getSpeciesList();
        }
      });
    },
  },
  created() {
    this.data = new Date();
  },
};
</script>
<style >
.vue-form-wizard.md .wizard-icon-circle {
  /* margin-bottom:15px; */
  width: 60px !important;
  height: 60px !important;
  font-size: 22px !important;
}
</style>